import apiRequest from "../../utils/apiRequest";

const markAllAsReadApi = async () => {
    return await apiRequest('makeAllread', 'get');
};

export default markAllAsReadApi;
